import React from 'react';
import Reveal from './Reveal';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const CONTACT_ROWS = [
  {
    icon: MapPin,
    label: 'Adresa kanceláře',
    content: (
      <p>
        Vrchlického 530
        <br />
        503 51 Chlumec nad Cidlinou IV
      </p>
    ),
  },
  {
    icon: Phone,
    label: 'Telefon',
    content: (
      <a href="tel:+420721207779" className="transition-colors hover:text-bronze">
        +420 721 207 779
      </a>
    ),
  },
  {
    icon: Mail,
    label: 'E-mail',
    content: (
      <a
        href="mailto:ak.jezkova@gmail.com"
        className="break-all transition-colors hover:text-bronze"
      >
        ak.jezkova@gmail.com
      </a>
    ),
  },
  {
    icon: Clock,
    label: 'Provozní doba',
    content: (
      <p>
        Pondělí – neděle, 8.00 – 20.00
      </p>
    ),
  },
];

export default function Contact() {
  return (
    <section id="kontakt" className="bg-paper py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal className="mb-10 max-w-2xl sm:mb-14">
          <p className="mb-3 text-xs uppercase tracking-[0.25em] text-bronze sm:text-sm">
            Kontakt
          </p>
          <h2 className="font-serif text-3xl text-ink sm:text-4xl">
            Advokátní kancelář v Chlumci nad Cidlinou
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
            Potřebujete právní pomoc? Ozvěte se telefonicky nebo e-mailem a
            domluvíme si termín konzultace.
          </p>
        </Reveal>

        <div className="grid gap-10 lg:grid-cols-5 lg:gap-16">
          <Reveal className="lg:col-span-3">
            {CONTACT_ROWS.map((row) => (
              <div
                key={row.label}
                className="flex items-start gap-4 border-b border-ink/10 py-5 first:pt-0 sm:gap-5 sm:py-6"
              >
                <row.icon
                  className="mt-1 h-5 w-5 shrink-0 text-bronze"
                  aria-hidden="true"
                />
                <div>
                  <h3 className="mb-1 text-xs uppercase tracking-[0.18em] text-slate-500">
                    {row.label}
                  </h3>
                  <div className="text-lg leading-relaxed text-ink">
                    {row.content}
                  </div>
                </div>
              </div>
            ))}
            <p className="pt-5 text-sm text-slate-500 sm:pt-6">
              IČ: 674 80 381 · Ev. č. ČAK: 12271 · Zapsána v seznamu obhájců
              ex offo
            </p>
          </Reveal>

          <Reveal delay={150} className="lg:col-span-2">
            <div className="bg-ink p-8 text-white sm:p-10">
              <h3 className="font-serif text-2xl sm:text-3xl">
                Potřebujete právní pomoc?
              </h3>
              <p className="mt-4 text-base leading-relaxed text-slate-300">
                Kontaktujte mě pro osobní konzultaci. Společně najdeme nejlepší
                řešení vaší právní situace.
              </p>

              <div className="mt-8 space-y-3">
                <a
                  href="tel:+420721207779"
                  className="flex items-center justify-center gap-2.5 bg-white px-6 py-3.5 text-base font-medium text-ink transition-all duration-300 hover:-translate-y-0.5 hover:bg-paper-dark active:translate-y-0"
                >
                  <Phone className="h-4 w-4" aria-hidden="true" />
                  <span>Zavolat</span>
                </a>
                <a
                  href="mailto:ak.jezkova@gmail.com"
                  className="flex items-center justify-center gap-2.5 border border-white/25 px-6 py-3.5 text-base font-medium text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-white/60 active:translate-y-0"
                >
                  <Mail className="h-4 w-4" aria-hidden="true" />
                  <span>Napsat e-mail</span>
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
